import React, { useState, useEffect } from 'react';
import desktopImg from '../../images/popup/desktop_scholarship.png';
import mobileImg from '../../images/popup/mobile_scholarship.png';

function Popup() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Show popup on every page load/reload
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <>
            {/* Backdrop */}
            <div className="popup-backdrop" onClick={handleClose}></div>

            {/* Popup Container */}
            <div className="popup-container">
                <button className="popup-close" onClick={handleClose} aria-label="Close popup">
                    &times;
                </button>

                {/* Images with two clickable zones: left scanner & right scanner */}
                <div className="popup-image-wrapper">
                    {/* Desktop Image */}
                    <img
                        src={desktopImg}
                        alt="Popup"
                        className="popup-image popup-image-desktop"
                    />
                    {/* Mobile Image */}
                    <img
                        src={mobileImg}
                        alt="Popup"
                        className="popup-image popup-image-mobile"
                    />
                    {/* Left scanner link */}
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSc6-9k_Y330SV2_SDMvyjfrn0N6X4z6F878yGsMYBiZ3APUlw/viewform?usp=dialog"
                        className="popup-zone popup-zone-left"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Left scanner form"
                    ></a>
                    {/* Right scanner link */}
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSfmKvDB6lo72_vHnWCU-XXnInB736hbnW7pgrmOuagvpVZtTg/viewform?usp=dialog"
                        className="popup-zone popup-zone-right"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Right scanner form"
                    ></a>
                </div>
            </div>
        </>
    );
}

export default Popup;
